import React, { useState, useEffect } from "react";
import { Button } from "../../../components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../../../components/ui/dialog";
import { Label } from "../../../components/ui/label";
import { Input } from "../../../components/ui/input";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../../components/ui/select";
import { Edit2Icon } from "lucide-react";

export function EditSymbolModal({
  symbol,
  product,
  category,
  handleUpdateSymbolValue,
}) {
  const [open, setOpen] = useState(false);

  const productOptions = [
    { value: "pledge_plus", title: "pledge_plus" },
    { value: "pledge_plus_mini", title: "pledge_plus_mini" },
  ];

  const categoryOptions = [
    { value: "commodity", title: "commodity" },
    { value: "index", title: "index" },
  ];

  const [newSymbol, setNewSymbol] = useState(symbol);
  const [newProduct, setNewProduct] = useState(product);
  const [newCategory, setNewCategory] = useState(category);

  // Sync modal fields with the row's actual props each time the dialog opens
  useEffect(() => {
    if (open) {
      setNewSymbol(symbol);
      setNewProduct(product);
      setNewCategory(category);
    }
  }, [open, symbol, product, category]);

  const handleUpdate = () => {
    if (!newSymbol.trim()) {
      return alert("Symbol cannot be empty");
    }
    handleUpdateSymbolValue(
      symbol,
      product,
      category,
      newSymbol.trim(),
      newProduct,
      newCategory
    );
    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button className="bg-zinc-800 text-white px-2.5 hover:bg-zinc-700 rounded-[5px]">
          <Edit2Icon className="w-4 h-4" />
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[525px] border-zinc-700">
        <DialogHeader>
          <DialogTitle className="text-white">Edit Symbol Config for {symbol}</DialogTitle>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <div className="grid grid-cols-1 items-center gap-2">
            <Label className="text-white">Symbol Name</Label>
            <Input
              type="text"
              value={newSymbol}
              onChange={(e) => setNewSymbol(e.target.value)}
              className="bg-[#1A1A1A] text-white border-zinc-700 focus:outline-none focus:border-blue-500"
            />
          </div>
          
          <div className="grid grid-cols-1 items-center gap-2">
            <Label className="text-white">Product</Label>
            <Select
              disabled
              value={newProduct}
              onValueChange={(value) => setNewProduct(value)}
            >
              <SelectTrigger className="text-white text-[15px] hover:bg-zinc-800 bg-zinc-900/50 opacity-70">
                <SelectValue placeholder="Select Product" />
              </SelectTrigger>
              <SelectContent className="border-zinc-700">
                <SelectGroup>
                  {productOptions.map((item) => (
                    <SelectItem key={item.value} value={item.value}>
                      {item.title}
                    </SelectItem>
                  ))}
                </SelectGroup>
              </SelectContent>
            </Select>
          </div>

          <div className="grid grid-cols-1 items-center gap-2">
            <Label className="text-white">Category</Label>
            <Select
              disabled
              value={newCategory}
              onValueChange={(value) => setNewCategory(value)}
            >
              <SelectTrigger className="text-white text-[15px] hover:bg-zinc-800 bg-zinc-900/50 opacity-70">
                <SelectValue placeholder="Select Category" />
              </SelectTrigger>
              <SelectContent className="border-zinc-700">
                <SelectGroup>
                  {categoryOptions.map((item) => (
                    <SelectItem key={item.value} value={item.value}>
                      {item.title}
                    </SelectItem>
                  ))}
                </SelectGroup>
              </SelectContent>
            </Select>
          </div>

        </div>
        <DialogFooter>
          <Button
            type="button"
            className="text-[16px] font-normal bg-zinc-800 text-white hover:bg-zinc-700"
            onClick={handleUpdate}
          >
            Update
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
